export const features = [
  {
    icon: 'ri-global-line',
    title: '无需下载',
    description: '打开浏览器即可访问91网页版入口，无需下载安装任何客户端软件，节省设备存储空间。',
  },
  {
    icon: 'ri-device-line',
    title: '跨平台使用',
    description: '支持Windows、Mac、Linux等操作系统，电脑、手机、平板均可使用，随时随地访问。',
  },
  {
    icon: 'ri-shield-flash-line',
    title: '安全可靠',
    description: 'HTTPS全程加密传输，支持两步验证登录，保障您的91网页版账号安全。',
  },
  {
    icon: 'ri-rocket-line',
    title: '极速体验',
    description: '全新优化的页面加载引擎，访问速度提升40%，让您的91网页版使用体验更加流畅。',
  },
  {
    icon: 'ri-refresh-line',
    title: '自动更新',
    description: '无需手动更新，91网页版功能升级自动生效，始终享受最新版本的全部功能。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '移动适配',
    description: '完美适配手机浏览器，支持添加到主屏幕，体验接近原生App的流畅感。',
  },
];